// extracted by mini-css-extract-plugin
export default {"container":"GP-z","modal":"HP-z","dimensions":"IP-z","brandName":"JP-z","productName":"KP-z","labelValue":"LP-z","recipientEmail":"MP-z","recommendedFit":"NP-z","hiddenField":"OP-z"};